import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import moment from 'moment';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Tooltip, IconButton } from '@material-ui/core';
import { LinkOff as LinkOffIcon, RemoveRedEye as ViewIcon, People as PeopleIcon } from '@material-ui/icons';
import { FHETable, DetailPanelUsers } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { dissociateSecurityUser, dissociateSecurityUserAndSwitchMaster } from '../../../data/Security/actions';

class TableSecurity extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dissociateSecurityUser: PropTypes.func.isRequired,
        dissociateSecurityUserAndSwitchMaster: PropTypes.func.isRequired,
        Securities: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        userId: PropTypes.number.isRequired,
        profile: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            dissociateLoading: null
        };
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/securities/detail/${rowData.id}` });
    };

    navigateToUser = event => {
        const { history } = this.props;
        return history.push({
            pathname: `/${history.environment}/user/detail/${event.currentTarget.getAttribute('data-userid')}`
        });
    };

    /* ACTIONS */
    dissociateUser = SecurityMac => {
        const { dissociateSecurityUser, userId } = this.props;
        this.setState({ dissociateLoading: SecurityMac });

        dissociateSecurityUser(SecurityMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.Security.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.Security.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMaster = SecurityMac => {
        const { dissociateSecurityUser, userId } = this.props;
        this.setState({ dissociateLoading: SecurityMac });

        dissociateSecurityUser(SecurityMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.Security.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.Security.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMasterAndSwitch = (SecurityMac, newMasterId) => {
        const { dissociateSecurityUserAndSwitchMaster, userId } = this.props;
        this.setState({ dissociateLoading: SecurityMac });

        dissociateSecurityUserAndSwitchMaster(SecurityMac, userId, newMasterId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.Security.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.Security.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateProduct = rowData => {
        const { dissociateLoading } = this.state;
        const { userId } = this.props;
        if (dissociateLoading === rowData.id) return false;
        if (rowData.otherUsers.length === 0 && rowData.userMasterId === userId) {
            Toastr.confirm(
                Translator.translate(`general.products.Security.table.action.dissociate.confirmRemoveMasterAlone`, rowData.macAddress),
                Translator.translate(`general.products.Security.table.action.dissociate.confirmRemoveMasterTitle`),
                {
                    onYes: () => {
                        this.dissociateMaster(rowData.id);
                    }
                }
            );
        } else if (rowData.userMasterId === userId) {
            Toastr.select(
                Translator.translate(`general.products.Security.table.action.dissociate.confirmRemoveMaster`, rowData.macAddress),
                Translator.translate(`general.products.Security.table.action.dissociate.confirmRemoveMasterTitle`),
                rowData.otherUsers,
                {
                    onYes: newMasterId => {
                        this.dissociateMasterAndSwitch(rowData.id, parseInt(newMasterId));
                    }
                }
            );
        } else {
            Toastr.confirm(
                Translator.translate(`general.products.Security.table.action.dissociate.confirmRemove`, rowData.macAddress),
                Translator.translate(`general.products.Security.table.action.dissociate.confirmRemoveTitle`),
                {
                    onYes: () => {
                        this.dissociateUser(rowData.id);
                    }
                }
            );
        }
    };

    /* RENDER */
    renderData = memoizeOne(Securities => {
        let result = [];

        Securities.map(Security => {
            result.push({
                id: Security.get('macAddress'),
                macAddress: Security.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                label: Security.get('label'),
                productType: Translator.translate(`general.products.Security.table.data.productType.${Security.get('productType')}`),
                email: Security.get('userEmail'),
                firmwareVersion: Security.get('firmwareVersion'),
                batteryLevel: Security.get('batteryLevel'),
                alarmState: Security.get('alarmState'),
                notifications: Security.get('notifications'),
                lastConnection: moment(Security.get('lastConnection')).format('DD/MM/YYYY HH:mm:ss'),
                usersList: Security.get('usersList'),
                otherUsers: Security.get('otherUsers'),
                userMasterId: Security.get('userMasterId')
            });
        });
        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [
                {
                    icon: LinkOffIcon,
                    onClick: this.dissociateProduct,
                    tooltip: Translator.translate(`general.products.Security.table.action.dissociate.tooltip`)
                }
            ],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('securityDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderDetails = memoizeOne(() => {
        return {
            renderToggleCell: ({ row, onToggle }) => {
                return (
                    <Tooltip title={Translator.translate('general.table.button.showUserList')} disableHoverListener={!row.userMasterId}>
                        <span>
                            <IconButton onClick={onToggle} disabled={!row.userMasterId}>
                                <PeopleIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
            renderPanel: ({ row }) => {
                return <DetailPanelUsers usersList={row.usersList} userMasterId={row.userMasterId} onClick={this.navigateToUser} />;
            }
        };
    });

    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('securityDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.productType'),
                name: 'productType'
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            },
            {
                title: Translator.translate('general.table.column.batteryLevel'),
                name: 'batteryLevel'
            },
            {
                title: Translator.translate('general.table.column.alarmState'),
                name: 'alarmState'
            },
            {
                title: Translator.translate('general.table.column.notifications'),
                name: 'notifications'
            },
            {
                title: Translator.translate('general.table.column.lastConnection'),
                name: 'lastConnection'
            }
        ];
    });

    renderSecurity() {
        const { Securities, profile } = this.props;

        return (
            <FHETable
                idTable="userDetailSecurity"
                columns={this.renderColumns(profile)}
                data={this.renderData(Securities)}
                actions={this.renderActions(profile)}
                rowDetail={this.renderDetails()}
                minified
            />
        );
    }

    render() {
        const { Securities } = this.props;
        return (
            <Fragment>
                {Securities.size > 0 ? this.renderSecurity() : Translator.translate(`general.products.Security.table.body.emptyDataSourceMessage`)}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const userId = props.match.params.userId;
    const users = state.environments[history.environment].data.Users.get('list');
    const actualUser = users.getIn([userId], new Map());
    let Securities = state.environments[history.environment].data.Security.get('list')
        .filter(Security => {
            return Security.getIn(['usersList'], []).indexOf(parseInt(userId)) !== -1;
        })
        .map(Security => {
            const masterUser = users.getIn([Security.getIn(['userMasterId'], '').toString()], new Map());
            let otherUsers = [];
            const usersList = Security.getIn(['usersList'], [])
                .map(_userId => {
                    const _user = users.getIn([_userId.toString()], new Map());
                    if (parseInt(userId) !== _user.get('_id'))
                        otherUsers.push({ id: _user.get('_id'), label: `${_user.get('firstname')} ${_user.get('lastname')}` });
                    return _user;
                })
                .sort(a => {
                    if (a.get('_id') === Security.get('userMasterId')) return -1;
                    else return 1;
                });
            return Security.set('userEmail', masterUser.get('email'))
                .set('usersList', usersList)
                .set('otherUsers', otherUsers);
        });
    return {
        profile: state.data.user,
        user: actualUser,
        users,
        Securities
    };
}

const styles = theme => ({
    detailPanelHeader: {
        color: theme.palette.text.secondary
    },
    masterRow: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark
    },
    userRow: {
        backgroundColor: 'white',
        color: theme.palette.text.secondary
    },
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { dissociateSecurityUser, dissociateSecurityUserAndSwitchMaster }), dispatch)
    )(withStyles(styles, { withTheme: true })(TableSecurity))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/Table/TableSecurity.js